import { createAction, props } from '@ngrx/store';
import { PaymentExecutionInterface, SellPreviewResponseInterface } from 'sp-arch-lib';
import { CardDetails } from 'sp-mark/models/card-details.interface';
import { PaymentCOnclusionContextType } from 'sp-mark/models/payment-conclusion-contest.type';
import { SellPreview } from 'sp-ui-lib';

export const retrieveSell = createAction(
  '[Payment Conclusion] Retrieve Sell',
  props<{ idOperation: number, operationContext: PaymentCOnclusionContextType, processCompleted: boolean }>()
);

export const retrieveSellSuccess = createAction(
  '[Payment Conclusion] Retrieve Sell Success',
  props<{ operation: SellPreview }>()
);

export const retrieveSellFailure = createAction(
  '[Payment Conclusion] Retrieve Sell Failure'
);

export const executePayment = createAction(
  '[Payment Conclusion] Execute Payment',
  props<{ payment: PaymentExecutionInterface }>()
);

export const actionRequiredOnPayment = createAction(
  '[Payment Conclusion] Action Required On Payment',
  props<{ actionRequired: boolean }>()
);

export const executePaymentWithNewInstallments = createAction(
  '[Payment Conclusion] Execute Payment With New Installments',
  props<{
    payer: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      eMailAddress: string
    };
  }>()
);

export const executePaymentSuccess = createAction(
  '[Payment Conclusion] Execute Payment Success'
);

export const handleExecutePaymentResponse = createAction(
  '[Payment Conclusion] Handle Execute Payment Response',
  props<{ sellResponse: Partial<SellPreviewResponseInterface> }>()
);

export const executePaymentFailure = createAction(
  '[Payment Conclusion] Execute Payment Failure'
);

export const executePaymentKo = createAction(
  '[Payment Conclusion] Execute Payment Ko',
  props<{ sellResponse: Partial<SellPreviewResponseInterface> }>()
);

export const attachPaymentMethod = createAction(
  '[Payment Conclusion] Attach Payment Method',
  props<{ payment: PaymentExecutionInterface }>()
);

export const listenToSellingState = createAction(
  '[Payment Conclusion] Listen To Selling State',
  props<{ paymentId: number }>()
);

export const listenToSellingStateResponse = createAction(
  '[Payment Conclusion] Listen To Selling State Response'
);

export const listenToSellingStateError = createAction(
  '[Payment Conclusion] Listen To Selling State Error'
);

export const resetOperationAvailability = createAction(
  '[Payment Conclusion] Reset Operation Availability'
);

export const setLoadingContent = createAction(
  '[Payment Conclusion] Set Loading Content',
  props<{ spinner: boolean }>()
);

export const storeCardDetails = createAction(
  '[ConcludeSelling] Store Xpay Nonce',
  props<{ cardDetails: CardDetails }>()
);

export const reorganizeInstallments = createAction(
  '[ConcludeSelling] Reorganize Installments',
  props<{ expiryMonth: number; expiryYear: number }>()
);

export const updateTotalInstallmentsAction = createAction(
  '[Payment Conclusion] Update total Installments',
  props<{totalInstallments: number}>()
);
